"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsersService = function UsersService(HttpService) {
  "ngInject";

  var getDataSource = function getDataSource(successCb, errorCb) {
    var dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: _env2.default.getApiUrl("entities/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total"
      },
      error: errorCb,
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    });

    return dataSource;
  };

  var getUserDetails = function getUserDetails(userId, successCb, failureCb) {
    HttpService.get("entities/" + userId, successCb, failureCb);
  };

  var getPayAgreements = function getPayAgreements(userId, successCb, failureCb) {
    HttpService.get("entities/" + userId + "/payagreements", successCb, failureCb);
  };

  var resetPayto = function resetPayto(userId, payAgreementId, successCb, failureCb) {
    HttpService.deleteResource("entities/" + userId + "/payagreements/" + payAgreementId, successCb, failureCb);
  };

  // Not supported.
  var updateUserDetails = function updateUserDetails(userId, payload, successCb, failureCb) {
    HttpService.patch("entities/" + userId, payload, successCb, failureCb);
  };

  var cancelSubscription = function cancelSubscription(userId, payload, successCb, failureCb) {
    HttpService.patch("entities/" + userId + "/cancelsubscription", payload, successCb, failureCb);
  };

  var refundInvoice = function refundInvoice(invoiceId, payload, successCb, failureCb) {
    HttpService.patch("entities/refundinvoice/" + invoiceId, payload, successCb, failureCb);
  };

  var getLoginAsUserAccessToken = function getLoginAsUserAccessToken(userId, successCb, failureCb) {
    HttpService.get("tokens/" + userId, successCb, failureCb);
  };

  var deleteUser = function deleteUser(userId, successCb, failureCb) {
    HttpService.deleteResource("entities/" + userId, successCb, failureCb);
  };

  var disableAccount = function disableAccount(userId, successCb, failureCb) {
    HttpService.patch("entities/" + userId + "/disableaccount", {}, successCb, failureCb);
  };

  var reactivateAccount = function reactivateAccount(userId, successCb, failureCb) {
    HttpService.patch("entities/" + userId + "/reactivateaccount", {}, successCb, failureCb);
  };

  var updateWalletBalance = function updateWalletBalance(userId, walletBalance, successCb, failureCb) {
    var payload = {
      userId: userId,
      walletBalance: walletBalance
    };
    HttpService.patch("entities/" + userId + "/updatewalletbalance", payload, successCb, failureCb);
  };

  var updateJobPostLimit = function updateJobPostLimit(userId, increaseBy, successCb, failureCb) {
    HttpService.patch("entities/" + userId + "/updatejobpostlimit", { increaseBy: parseInt(increaseBy) }, successCb, failureCb);
  };

  // Not supported.
  var resetPassword = function resetPassword(userId, payload, successCb, failureCb) {
    HttpService.post("bigfoot/users/changepassword/" + userId, payload, successCb, failureCb);
  };

  var getRatingsDataSource = function getRatingsDataSource(userId, isClient) {
    var dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: _env2.default.getApiUrl("entities/" + userId + "/ratings?isClient=" + isClient),
          contentType: "application/json",
          type: "GET",
          beforeSend: _onBeforeSend
        },
        update: {
          url: function url(item) {
            return _env2.default.getApiUrl("entities/" + userId + "/ratings/" + item.id + "?isClient=" + isClient);
          },
          contentType: "application/json",
          type: "PATCH",
          beforeSend: _onBeforeSend
        },
        parameterMap: function parameterMap(data, type) {
          if (type === "update") {
            return (0, _stringify2.default)({
              category1: data.category1,
              category2: data.category2,
              category3: data.category3,
              category4: data.category4

            });
          }
        }
      },
      schema: {
        model: {
          id: "id",
          fields: {
            id: { editable: false },
            ratingById: { editable: false },
            firstName: { editable: false },
            lastName: { editable: false },
            category1: { type: "number", validation: { min: 0, max: 5 } },
            category2: { type: "number", validation: { min: 0, max: 5 } },
            category3: { type: "number", validation: { min: 0, max: 5 } },
            category4: { type: "number", validation: { min: 0, max: 5 } },
            ratingSum: { editable: false },
            ratingAvg: { editable: false },
            feedback: { editable: false },
            jobId: { editable: false },
            ratingDate: { editable: false }
          }
        }
      },
      serverFiltering: false,
      serverPaging: false,
      serverSorting: false,
      pageSize: 50
    });

    return dataSource;
  };

  var getMessagesDataSource = function getMessagesDataSource(userId, convertToLocalTime, successCb) {
    var dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: _env2.default.getApiUrl("entities/" + userId + "/messages/" + convertToLocalTime),
          contentType: "application/json",
          type: "GET",
          beforeSend: _onBeforeSend

        }
      },
      change: successCb,
      serverFiltering: false,
      serverPaging: false,
      serverSorting: false,

      pageSize: 50
    });

    return dataSource;
  };

  return {
    getDataSource: getDataSource,
    getUserDetails: getUserDetails,
    updateUserDetails: updateUserDetails,

    cancelSubscription: cancelSubscription,
    refundInvoice: refundInvoice,
    getLoginAsUserAccessToken: getLoginAsUserAccessToken,
    deleteUser: deleteUser,
    disableAccount: disableAccount,
    updateWalletBalance: updateWalletBalance,
    updateJobPostLimit: updateJobPostLimit,
    reactivateAccount: reactivateAccount,
    resetPassword: resetPassword,
    getMessagesDataSource: getMessagesDataSource,
    getRatingsDataSource: getRatingsDataSource,
    getPayAgreements: getPayAgreements,
    resetPayto: resetPayto
  };
};

function _onBeforeSend(req) {
  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  var filters = [];

  if (data.filter) filters = data.filter.filters;

  var query = (0, _assign2.default)({}, { filters: filters }, data);
  delete query.filter;

  console.log("Query::", query);

  return (0, _stringify2.default)(query);
}

exports.default = UsersService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/users.service.js
 **/